
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
      marginTop:20
    },
    table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
    },
    items: {
        padding: '1%',
        display:'flex',
        flexDirection:'row'
    },
    
    item_header: {
        fontWeight: 600,
        paddingLeft: '5%',
        width:'50%'
    },
    
    item_body: {
        padding: '6px ',
        width:'40%'
    },
    
    main_header: {
        padding: '1%',
        color: 'white',
        marginBottom: '3%',
        textAlign:'center',
        fontSize:'120%'
    },

    input: {
        width: '40%',
        height: 25,
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
    },
    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '6%',
    },

    textbox: {
        width: '50%',
        height: 75,
      },

    message: {
        fontSize: '120%',
        fontWeight: 600,
        textAlign: 'center'
    }

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/addExpense/style.js